import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const CheckoutCancel = () => {
  return (
    <div className="pt-20 min-h-screen bg-[#FAFAF9] flex items-center justify-center" data-testid="checkout-cancel">
      <div className="text-center px-6 max-w-lg">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-8">
          <XCircle className="w-10 h-10 text-red-500" />
        </div>
        
        <h1 
          className="text-4xl font-light text-[#1C1917] mb-4"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Pago cancelado
        </h1>
        
        <p className="text-lg text-[#57534E] mb-8">
          Tu pago fue cancelado. No se realizó ningún cargo a tu tarjeta. 
          Tu carrito sigue disponible si deseas completar la compra.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/cart" 
            className="btn-primary inline-flex items-center justify-center space-x-2"
            data-testid="back-to-cart-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Volver al carrito</span>
          </Link>
          <Link to="/shop" className="btn-secondary" data-testid="continue-shopping-btn">
            Seguir comprando
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
